import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Tabs, Input } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ROOT_URL } from "../../../constants/api";
import { nofication } from "../../../commons/Nofication";
import Upload from "../../../commons/Upload";
import AddressForm from "../../../components/form/addressForm";
import MainLayout from "../../../components/mainLayout";
import { authApis } from "../../../services/authApi";
import "./index.scss";
import BackButton from "../../../commons/BackButton";

const { TextArea } = Input;

const { TabPane } = Tabs;
const style = { padding: "8px 20px" };
const onChange = (key) => {
    console.log(key);
};

const Register = () => {
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [form] = Form.useForm();
    let { id } = useParams();
    const [content, setContent] = useState({
        content_vi: "",
        content_en: "",
        content_kr: "",
        content_vi: "",
        content_en: "",
    });
    useState(() => {
        if (id) {
            authApis
                .getAddressBanner(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.address);
                        setContent({
                            content_vi: data.address?.content_vi ?? "<p></p>",
                            content_en: data.address?.content_en ?? "<p></p>",
                            content_kr: data.address?.content_kr ?? "<p></p>",
                            content_cn: data.banner?.content_cn ?? '<p></p>',
                            content_jp: data.banner?.content_jp ?? '<p></p>',
                        });
                        setImageUrl(
                            data.address?.image
                                ? ROOT_URL + data.address.image
                                : ""
                        );
                    } else {
                        nofication(
                            "error",
                            "Thất bại",
                            "Vui lòng kiểm tra lại thông tin !"
                        );
                    }
                })
                .catch((errors) => {
                    nofication(
                        "error",
                        "Thất bại",
                        "Không kết nối được server"
                    );
                    console.log(errors);
                });
        }
    });

    const onChangeContentValue = (data) => {};

    const onFinish = async () => {
        const values = form.getFieldValue();
        console.log(values);
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (
                key === "content_vi" ||
                key === "content_en" ||
                key === "content_kr" || key === 'content_cn' || key === 'content_jp'
            ) {
                formData.append(
                    key,
                    values[key]?.editor
                        ? values[key]?.editor.getData()
                        : values[key]
                );
            } else {
                formData.append(key, values[key]);
            }
        }
        id && formData.append("id", id);
        formData.append("imageUrl", imageUrl);
        await authApis
            .address(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication("success", "Thành công", "Cập nhật thành công!");
                } else {
                    nofication(
                        "error",
                        "Thất bại",
                        "Vui lòng kiểm tra lại thông tin !"
                    );
                }
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Không kết nối được server");
                console.log(errors);
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Location"
            link="/location/"
            titleNew="Contact / Edit"
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                colon={true}
            >
                <Row gutter={16}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <AddressForm
                                        lang={"vi"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                    />
                                </TabPane>
                                {/* <TabPane tab="Tiếng anh" key="2">
                                    <AddressForm
                                        lang={"en"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                    />
                                </TabPane>
                                <TabPane tab="Tiếng hàn" key="3">
                                    <AddressForm
                                        lang={"kr"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                    />
                                </TabPane>
                                <TabPane tab="Tiếng trung" key="4">
                                    <AddressForm lang={'cn'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                                <TabPane tab="Tiếng nhật" key="5">
                                    <AddressForm lang={'jp'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane> */}
                            </Tabs>
                            <Form.Item
                                label="Email"
                                name={"email"}
                                colon={true}
                            >
                                <TextArea
                                    autoSize={{ minRows: 1, maxRows: 5 }}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Phone"
                                name={"phone"}
                                colon={true}
                            >
                                <TextArea
                                    autoSize={{ minRows: 1, maxRows: 5 }}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
